import React from 'react'

const Dummy = () => {
  return (
    <div>Welcome to lancellot knights</div>
  )
}

export default Dummy